import { formatCurrency, getDelimitedString, pn } from "@compass/core";
import { DevExpressReport, renderReportColumn, renderReportSummary } from "components";
import { DevExpressExportProps } from "components/common/DevExpressReport/DevExpressExportProps";
import { MatchReportContributorDetail, ReportPropertyBase } from "generated/openApi";

export const ContributorDetail = (props: { report: MatchReportContributorDetail }) => {
  const exportProps: DevExpressExportProps = {
    header: "Match Contributor Details",
    filename: "MatchContributorDetails",
    tenantName: props.report.tenantName,
    infoTuples: [
      ["Date Fro:", props.report.dateFrom ? new Date(props.report.dateFrom).toDateString() : undefined],
      ["Date To", props.report.dateTo ? new Date(props.report.dateTo).toDateString() : undefined],
      [
        "Partner",
        props.report.partners
          ? getDelimitedString(
              props.report.partners.map((x) => x.name),
              ", "
            )
          : undefined,
      ],
      [
        "Sub-Partner",
        props.report.subPartners
          ? getDelimitedString(
              props.report.subPartners.map((x) => x.name),
              ", "
            )
          : undefined,
      ],
      ["Status", props.report.reviewName],
      ["Grand Total", formatCurrency(props.report.grandTotal)],
    ],
  };

  return (
    <DevExpressReport
      dataSource={props.report.contributorDetailRows}
      exportFormats={["pdf", "excel", "csv"]}
      onExporting={() => {
        return exportProps;
      }}
    >
      {props.report.reportProperties?.map((property) =>
        renderReportColumn({
          property: property,
          propertyKey: pn<ReportPropertyBase>("propertyName"),
        })
      )}

      {renderReportSummary({
        properties: props.report.reportProperties,
        propertyKey: pn<ReportPropertyBase>("propertyName"),
      })}
    </DevExpressReport>
  );
};
